module.exports = __webpack_public_path__ + "img/packagetour_mt.dc3d2490.png";